var _rect, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 153,
    viewBox: "0 0 252 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 4,
    width: 186,
    height: 138,
    rx: 4,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5990_22137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 145,
    height: 35,
    rx: 4,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 20H54C52.3431 20 51 21.3431 51 23C51 24.6569 52.3431 26 54 26H80C81.6569 26 83 24.6569 83 23C83 21.3431 81.6569 20 80 20Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33H54C52.3431 33 51 34.3431 51 36C51 37.6569 52.3431 39 54 39H98C99.6569 39 101 37.6569 101 36C101 34.3431 99.6569 33 98 33Z",
    fill: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 39C38.7467 39 43 34.7467 43 29.5C43 24.2533 38.7467 20 33.5 20C28.2533 20 24 24.2533 24 29.5C24 34.7467 28.2533 39 33.5 39Z",
    fill: "#EFD01E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5990_22137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 98,
    width: 145,
    height: 35,
    rx: 4,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106H54C52.3431 106 51 107.343 51 109C51 110.657 52.3431 112 54 112H80C81.6569 112 83 110.657 83 109C83 107.343 81.6569 106 80 106Z",
    fill: "#D7D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98 119H54C52.3431 119 51 120.343 51 122C51 123.657 52.3431 125 54 125H98C99.6569 125 101 123.657 101 122C101 120.343 99.6569 119 98 119Z",
    fill: "#E9E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 125C38.7467 125 43 120.747 43 115.5C43 110.253 38.7467 106 33.5 106C28.2533 106 24 110.253 24 115.5C24 120.747 28.2533 125 33.5 125Z",
    fill: "#EFD01E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5990_22137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 55,
    width: 145,
    height: 35,
    rx: 4,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155 63H129C127.343 63 126 64.3431 126 66C126 67.6569 127.343 69 129 69H155C156.657 69 158 67.6569 158 66C158 64.3431 156.657 63 155 63Z",
    fill: "#D7D7D7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173 76H129C127.343 76 126 77.3431 126 79C126 80.6569 127.343 82 129 82H173C174.657 82 176 80.6569 176 79C176 77.3431 174.657 76 173 76Z",
    fill: "#E9E9E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 82C113.747 82 118 77.7467 118 72.5C118 67.2533 113.747 63 108.5 63C103.253 63 99 67.2533 99 72.5C99 77.7467 103.253 82 108.5 82Z",
    fill: "#EFD01E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5990_22137",
    x: 0,
    y: 0,
    width: 177,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5990_22137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5990_22137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5990_22137",
    x: 0,
    y: 86,
    width: 177,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5990_22137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5990_22137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5990_22137",
    x: 75,
    y: 43,
    width: 177,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 0 0.844139 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5990_22137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5990_22137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2fa4bd75cea71bbf6e404eb264baba8c.svg";
export { ForwardRef as ReactComponent };